"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTION_NAMES = void 0;
exports.COLLECTION_NAMES = {
    BOOKS: 'books',
    BOOK_PAGES: 'bookPages',
    TEXTS: 'texts',
    READING_HISTORY_ITEMS: 'readingHistoryItems',
    USER_PROFILES: 'userProfiles',
    SCHEDULED_EMAILS: 'scheduledEmails',
    PARAGRAPH_COMMENTS: 'paragraphComments',
    ANALYTICS_EVENTS: 'analyticsEvents',
    TEXT_QUOTES: 'textQuotes',
};
//# sourceMappingURL=CollectionNames.js.map